var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deploy"}},[_c('b-btn',{attrs:{"size":"sm","variant":"outline-success"},on:{"click":_vm.deployXML}},[_vm._v("Deploy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }